import React, { useEffect, useState } from "react";
import api, { formatApiError } from "../../lib/api";
import { Window, Dialog, ConfirmDialog, EmptyState, Loading } from "../../components/VB";
import { toast } from "sonner";
import { Plus, Trash2, KeyRound } from "lucide-react";

export default function UserManagement() {
  const [items, setItems] = useState([]);
  const [emps, setEmps] = useState([]);
  const [clients, setClients] = useState([]);
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ email: "", password: "", name: "", role: "karyawan", employee_id: "" });
  const [del, setDel] = useState(null);
  const [pwdTarget, setPwdTarget] = useState(null);
  const [newPwd, setNewPwd] = useState("");

  const load = async () => {
    setLoading(true);
    try {
      const [u, e, c, g] = await Promise.all([
        api.get("/users"), api.get("/employees"),
        api.get("/clients").catch(() => ({ data: [] })),
        api.get("/project-groups").catch(() => ({ data: [] })),
      ]);
      setItems(u.data); setEmps(e.data); setClients(c.data); setGroups(g.data);
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    setLoading(false);
  };
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/users", form);
      toast.success("User tersimpan");
      setOpen(false); setForm({ email: "", password: "", name: "", role: "karyawan", employee_id: "" }); load();
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
  };
  const doDelete = async () => {
    try { await api.delete(`/users/${del.id}`); toast.success("Dihapus"); setDel(null); load(); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
  };
  const changePwd = async () => {
    try {
      await api.put(`/users/${pwdTarget.id}`, { password: newPwd });
      toast.success("Password diperbarui"); setPwdTarget(null); setNewPwd("");
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
  };

  return (
    <Window
      title="User Management"
      actions={<button className="vb-btn" onClick={() => setOpen(true)} data-testid="add-user"><Plus className="w-3 h-3 inline mr-1" />Tambah User</button>}
    >
      {loading ? <Loading /> : items.length === 0 ? <EmptyState /> : (
        <table className="vb-table">
          <thead><tr><th>Email</th><th>Nama</th><th>Role</th><th>Tautan</th><th>Aksi</th></tr></thead>
          <tbody>
            {items.map((u) => {
              let tautan = "-";
              if (u.employee_id) tautan = emps.find((e) => e.id === u.employee_id)?.nama_lengkap || "-";
              else if (u.client_id) tautan = `Client: ${clients.find((c) => c.id === u.client_id)?.nama || u.client_id}`;
              else if (u.group_id) tautan = `Group Client: ${groups.find((g) => g.id === u.group_id)?.nama || u.group_id}`;
              return (
              <tr key={u.id}>
                <td>{u.email}</td><td>{u.name}</td><td>{u.role}</td>
                <td style={{ fontSize: 11 }}>{tautan}</td>
                <td>
                  <button className="vb-btn" style={{ padding: "2px 6px", marginRight: 4 }} onClick={() => setPwdTarget(u)} data-testid={`pwd-${u.id}`}><KeyRound className="w-3 h-3" /></button>
                  <button className="vb-btn-danger" style={{ padding: "2px 6px" }} onClick={() => setDel(u)} data-testid={`user-del-${u.id}`}><Trash2 className="w-3 h-3" /></button>
                </td>
              </tr>
              );
            })}
          </tbody>
        </table>
      )}

      <Dialog open={open} onClose={() => setOpen(false)} title="Tambah User"
        footer={<><button className="vb-btn" onClick={() => setOpen(false)}>Batal</button><button className="vb-btn-primary" onClick={submit} data-testid="user-save">Simpan</button></>}>
        <form onSubmit={submit}>
          <div className="vb-form-row"><label className="vb-label">Email*</label>
            <input type="email" className="vb-input" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required data-testid="user-email" /></div>
          <div className="vb-form-row"><label className="vb-label">Password*</label>
            <input type="password" className="vb-input" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} required data-testid="user-password" /></div>
          <div className="vb-form-row"><label className="vb-label">Nama*</label>
            <input className="vb-input" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required data-testid="user-name" /></div>
          <div className="vb-form-row"><label className="vb-label">Role*</label>
            <select className="vb-select" value={form.role} onChange={(e) => setForm({ ...form, role: e.target.value })} data-testid="user-role">
              <option value="karyawan">Karyawan</option>
              <option value="admin">Admin</option>
              <option value="client">Client</option>
            </select>
            {form.role === "client" && (
              <span style={{ fontSize: 11, color: "#666" }}>Buat akunnya di sini, lalu <strong>tautkan</strong> ke data Client atau Group Client lewat <strong>Payment Website → Pengaturan → Client / Group Client</strong>. Sampai ditaut, akun ini belum bisa mengakses portal.</span>
            )}
          </div>
          {form.role !== "client" && (
            <div className="vb-form-row"><label className="vb-label">Hubungkan ke Karyawan</label>
              <select className="vb-select" value={form.employee_id} onChange={(e) => setForm({ ...form, employee_id: e.target.value })} data-testid="user-emp">
                <option value="">- tidak terhubung -</option>
                {emps.map((e) => <option key={e.id} value={e.id}>{e.nama_lengkap}</option>)}
              </select></div>
          )}
        </form>
      </Dialog>

      <Dialog open={!!pwdTarget} onClose={() => setPwdTarget(null)} title="Reset Password"
        footer={<><button className="vb-btn" onClick={() => setPwdTarget(null)}>Batal</button><button className="vb-btn-primary" onClick={changePwd} data-testid="pwd-save">Simpan</button></>}>
        <p style={{ fontSize: 13 }}>Reset password untuk <b>{pwdTarget?.email}</b></p>
        <input type="password" className="vb-input" placeholder="Password baru" value={newPwd} onChange={(e) => setNewPwd(e.target.value)} data-testid="pwd-new" />
      </Dialog>

      <ConfirmDialog open={!!del} onClose={() => setDel(null)} onConfirm={doDelete} message={`Hapus user "${del?.email}"?`} />
    </Window>
  );
}
